import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';

export class Adicionales{
  indicatorId?: Number;
  activityId ?: Number;
  name?: string;
  amount?: Number;
  files?: string;
  note?: string;
  type?: string;
} 

export class comment{
  comment?: string;
  created_at?: string;
  additionalId?: number
}



@Injectable({
  providedIn: 'root'
})
export class AdicionalService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersAr = new HttpHeaders().append('enctype', 'multipart/form-data')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  constructor(
    private http: HttpClient, 
    private cookies: CookieService,
    private apollo: Apollo
  ) { }

  public postAdicionales(adicional: any): Observable<any>{
    const ad: Adicionales = {
      indicatorId: Number(adicional.indicadorId),
      name: adicional.nombre,
      amount: Number(adicional.monto),
      note: adicional.nota,
      type: adicional.tipo,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"adicional";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public postAdicionalesActiviti(adicional: any): Observable<any>{
    const ad: Adicionales = {
      activityId: Number(adicional.actividadId),
      name: adicional.nombre,
      amount: Number(adicional.monto),
      note: adicional.nota,
      type: adicional.tipo,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"adicional";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }

  public patchAdicionales(adicional: any, id: any): Observable<any>{
    const ad: Adicionales = {
      name: adicional.name,
      amount: Number(adicional.amount),
      // files: adicional.files,
      note: adicional.note,
      type: adicional.type,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"adicional/"+adicional.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public patchAdicionalesValues(adicional: any): Observable<any>{
      const ad: Adicionales = {
        amount: Number(adicional.amount),
        files: adicional.files,
        note: adicional.note,
        type: adicional.type,
      }
      const body = JSON.stringify(ad);
      const apiURL = this.apiURL+"adicional/"+adicional.id;
      return this.http.patch(`${apiURL}`, body, {headers: this.headers});
    }

  public patchAdicionalesNombre(adicional: any): Observable<any>{
    const ad: Adicionales = {
      name: adicional.name,
    }
    const body = JSON.stringify(ad);
    const apiURL = this.apiURL+"adicional/"+adicional.id;
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public deleteAdicional(adicional: any): Observable<any>{
    const apiURL = this.apiURL+"adicional/"+Number(adicional.id);
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  public postComment(com: any, idAct: number): Observable<any>{
    const coment: comment = {
      comment: com.comment,
      created_at: com.createdAt,
      additionalId: Number(idAct),
    }
    const body = JSON.stringify(coment);
    // const apiURL = this.apiURL.replace('/v1', '')+"comments";
    const apiURL = this.apiURL+"adicional/"+idAct+"/comments";
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }
  public patchComment(com: any, idAct: number): Observable<any>{
    const coment: comment = {
      comment: com.comment,
    }
    const body = JSON.stringify(coment);
    const apiURL = this.apiURL+"adicional/"+idAct+"/comments/"+Number(com.id);
    return this.http.patch(`${apiURL}`, body, {headers: this.headers});
  }
  public deleteComment(com: any, idAct: number): Observable<any>{
    const apiURL = this.apiURL+"adicional/"+idAct+"/comments/"+Number(com.id);
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }

  public postFile(fil: any, idAd: number, fecha: any): Observable<any>{
    const formData: FormData = new FormData();
    formData.append('file', fil);
    formData.append('created_at', fecha);

    const apiURL = this.apiURL+"adicional/"+idAd+"/file";
    return this.http.post(`${apiURL}`, formData, {headers: this.headersAr});
  }
  public getFile(idAd: any, idFil: any): Observable<any>{
    const apiURL = this.apiURL+"adicional/"+idAd+"/file/"+idFil;
    return this.http.get(`${apiURL}`, {headers: this.headers, 'responseType'  : 'arraybuffer' as 'json'});
  }
  public deleteFile(idAd: any, idFil: any): Observable<any>{
    const apiURL = this.apiURL+"adicional/"+idAd+"/file/"+idFil;
    return this.http.delete(`${apiURL}`, {headers: this.headers, 'responseType'  : 'arraybuffer' as 'json'});
  }

}
